export function updateViewURL (router, props) {
  const route = router.resolve(props);
  history.pushState({}, '', route.href)
}
